/**
 * Better Auth client configuration for SEER Futures
 *
 * React client with all plugin clients configured.
 * Used in client components for auth state management,
 * login/register forms, MFA flows, and passkey operations.
 */

'use client';

import { createAuthClient } from 'better-auth/react';
import { twoFactorClient, adminClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';
import { ssoClient } from '@better-auth/sso/client';
import { authReturnPath } from './return-path';

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect() {
        const callback = authReturnPath(new URLSearchParams(window.location.search).get('callbackUrl'));
        window.location.href = `/auth/mfa-verify?callbackUrl=${encodeURIComponent(callback)}`;
      },
    }),
    passkeyClient(),
    ssoClient(),
    adminClient(),
  ],
});
